module.exports = __webpack_public_path__ + "static/img/jzsxtLogoN.578d96b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jzsxtLogoN.jpg
// module id = Soih
// module chunks = 2